import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import StepperButton from './StepperButton'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {useNavigate} from 'react-router-dom'
import {filter, find} from 'lodash'
import Dropdown from 'react-bootstrap/Dropdown'
import {Button} from 'react-bootstrap'

interface IIncomeDocumentStepper {
  document: IIncomeDocument
}

const IncomeDocumentStepper: React.FC<IIncomeDocumentStepper> = (props) => {
  const { document } = props
  const navigate = useNavigate()

  if (!document) return <></>

  const isVoided = document.state === 'voided'
  const isInitialDocument = !document.linkingDocumentId
  const childrenDocuments = document?.childrenDocuments || []
  const btnClass = 'btn-income-document-stepper'

  const _renderQuotationStepper = () => {
    const isAccepted = ['accepted'].includes(document.state)
    const relateInvoiceDocument = find(childrenDocuments, {type: 'invoice'})
    const relateInvoicePayments = relateInvoiceDocument?.incomeDocumentPayments || []
    const relateInvoiceReceiptDocuments = relateInvoiceDocument?.childrenDocuments?.filter((doc: any) => doc.type === 'receipt')

    const taxInvoice = find(relateInvoiceDocument?.childrenDocuments, {type: 'tax-invoice'})
    const taxReceipt = find(relateInvoiceReceiptDocuments?.childrenDocuments, {type: 'tax-invoice'})

    return (
      <>
        <StepperButton
          title={'ใบเสนอราคา'}
          state={'passed'}
        />
        <StepperButton
          title={'ตอบรับแล้ว'}
          state={isVoided ? 'disabled' : (isAccepted ? 'passed' : 'pending')}
        />
        <StepperButton
          title={'ใบแจ้งหนี้'}
          state={isAccepted ? relateInvoiceDocument ? 'passed' : 'pending' : 'disabled'}
          onClick={() => {
            if (relateInvoiceDocument) {
              navigate(`/invoice/${relateInvoiceDocument.id}/detail`)
              return
            }

            navigate(`/invoice/create?docId=${document.id}`)
          }}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={isAccepted
            ? (relateInvoiceDocument ? (relateInvoiceDocument?.state === 'paid' ? 'passed' : 'pending') : 'disabled')
            : 'disabled'}
        />
        <StepperButton
          title={'ใบเสร็จรับเงิน'}
          state={isAccepted
            ? (relateInvoiceReceiptDocuments?.length
              ? 'passed'
              : (relateInvoiceDocument?.state === 'paid' ? 'pending' : 'disabled')
            ) : 'disabled'}
          onClick={() => {
            if (!relateInvoiceReceiptDocuments) return
            if (relateInvoiceReceiptDocuments?.length === 1) {
              navigate(`/revenue-receipt/${relateInvoiceReceiptDocuments?.[0]?.id}/detail`)
            }
          }}
        />
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={taxInvoice || taxReceipt ? 'passed' : 'disabled'}
          onClick={() => {
            if (taxInvoice?.linkingDocumentId) {
              navigate(`/invoice/${taxInvoice?.linkingDocumentId}/detail`)
              return
            }

            if (taxReceipt?.linkingDocumentId) {
              navigate(`/revenue-receipt/${taxReceipt?.linkingDocumentId}/detail`)
              return
            }
          }}
        />
      </>
    )
  }

  const _renderDepositStepper = () => {
    const taxDocument = find(document.childrenDocuments, {type: 'tax-invoice'})
    const quotationDocument = document?.linkingDocument?.type === 'quotation' ? document.linkingDocument : undefined

    return (
      <>
        {quotationDocument && (
          <>
            <StepperButton
              title={'ใบเสนอราคา'}
              state={'passed'}
              onClick={() => {
                navigate(`/quotation/${quotationDocument.id}/detail`)
              }}
            />
            <StepperButton
              title={'ตอบรับแล้ว'}
              state={'passed'}
            />
          </>
        )}
        <StepperButton
          title={'ใบรับเงินมัดจำ'}
          state={'passed'}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={['await-deduct', 'deducted'].includes(document.state)
            ? 'passed'
            : (['outstanding', 'overdue'].includes(document.state) ? 'pending' : 'disabled')}
        />
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={taxDocument ? 'passed' : 'disabled'}
        />
      </>
    )
  }

  const _renderInvoiceStepper = () => {
    const taxDocument = find(document.childrenDocuments, {type: 'tax-invoice'})
    const receiptDocuments = document.childrenDocuments.filter(v => v.type === 'receipt')
    const quotationDocument = document?.linkingDocument?.type === 'quotation' ? document.linkingDocument : undefined
    const payments = document?.incomeDocumentPayments
    // const currentBillingHistory = find(document?.billingHistories, {originalDocumentId: document.id})
    // const billingHistoryReceiptDocuments = filter(currentBillingHistory?.incomeDocument?.childrenDocuments, {type: 'receipt'})

    const billingHistoryDocuments = filter(document?.billingHistories, {originalDocumentId: document.id})
    const billingHistoryReceiptDocuments = billingHistoryDocuments?.map((doc) => {
      return filter(doc?.incomeDocument?.childrenDocuments, {type: 'receipt'})
    }).flat()

    const billingPayments = billingHistoryDocuments?.map((doc) => {
      return doc?.incomeDocument?.incomeDocumentPayments
    }).flat()

    const allPayments = [
      ...payments,
      ...billingPayments,
    ]

    const allReceiptDocuments = [
      ...receiptDocuments,
      ...billingHistoryReceiptDocuments
    ]

    return (
      <>
        {quotationDocument && (
          <>
            <StepperButton
              title={'ใบเสนอราคา'}
              state={'passed'}
              onClick={() => {
                navigate(`/quotation/${quotationDocument.id}/detail`)
              }}
            />
            <StepperButton
              title={'ตอบรับแล้ว'}
              state={'passed'}
            />
          </>
        )}
        <StepperButton
          title={'ใบแจ้งหนี้'}
          state={'passed'}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={document?.state === 'paid' ? 'passed' : 'pending'}
          counter={allPayments?.length}
        />
        <StepperButton
          title={'ใบเสร็จรับเงิน'}
          state={(allReceiptDocuments.length) ? 'passed' : 'disabled'}
          counter={allReceiptDocuments.length}
          documents={allReceiptDocuments}
          onClick={() => {
            if (!allReceiptDocuments.length) return
            if (allReceiptDocuments.length === 1) {
              navigate(`/revenue-receipt/${allReceiptDocuments[0].id}/detail`)
              return
            }
          }}
        />
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={taxDocument ? 'passed' : 'disabled'}
        />
      </>
    )
  }

  const _renderReceiptStepper = () => {
    const taxDocument = find(document.childrenDocuments, {type: 'tax-invoice'})
    const invoiceDocument = document?.linkingDocument?.type === 'invoice' ? document.linkingDocument : undefined
    const invoiceTaxDocument = find(invoiceDocument?.childrenDocuments, {type: 'tax-invoice'})
    const quotationDocument = invoiceDocument?.linkingDocument?.type === 'quotation' ? invoiceDocument.linkingDocument : undefined

    return (
      <>
        {quotationDocument && (
          <>
            <StepperButton
              title={'ใบเสนอราคา'}
              state={'passed'}
              onClick={() => {
                navigate(`/quotation/${quotationDocument.id}/detail`)
              }}
            />
            <StepperButton
              title={'ตอบรับแล้ว'}
              state={'passed'}
            />
          </>
        )}
        {invoiceDocument && (
          <StepperButton
            title={'ใบแจ้งหนี้'}
            state={'passed'}
            onClick={() => {
              navigate(`/invoice/${invoiceDocument.id}/detail`)
            }}
          />
        )}
        <StepperButton
          title={'ใบเสร็จรับเงิน'}
          state={'passed'}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={document.state === 'paid' ? 'passed' : 'disabled'}
        />
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={taxDocument || invoiceTaxDocument ? 'passed' : 'disabled'}
          onClick={() => {
            if (invoiceTaxDocument) {
              navigate(`/invoice/${invoiceDocument.id}/detail`)
            }
          }}
        />
      </>
    )
  }

  const _renderTaxInvoiceStepper = () => {
    return (
      <>
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={'passed'}
        />
      </>
    )
  }

  const _renderCreditDebitStepper = () => {
    const invoiceDocument = document?.linkingDocument?.type === 'invoice' ? document?.linkingDocument : undefined
    const receiptDocument = document?.linkingDocument?.type === 'receipt' ? document?.linkingDocument : undefined

    return (
      <>
        {invoiceDocument && (
          <StepperButton
            title={'ใบแจ้งหนี้'}
            state={'passed'}
            onClick={() => {
              navigate(`/invoice/${invoiceDocument.id}/detail`)
            }}
          />
        )}
        {receiptDocument && (
          <StepperButton
            title={'ใบเสร็จรับเงิน'}
            state={'passed'}
            onClick={() => {
              navigate(`/revenue-receipt/${receiptDocument.id}/detail`)
            }}
          />
        )}
        {(invoiceDocument?.issueTaxInvoice || receiptDocument?.issueTaxInvoice) && (
          <StepperButton
            title={'ออกใบกำกับภาษี'}
            state={'passed'}
          />
        )}
        <StepperButton
          title={'ใบลดหนี้'}
          state={'passed'}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={document.state === 'paid' ? 'passed' : 'pending'}
        />
      </>
    )
  }

  const _renderBillingStepper = () => {
    const receiptDocument = find(document.childrenDocuments, {type: 'receipt'})
    const taxReceipt = receiptDocument?.linkingDocument?.type === 'tax-invoice' ? receiptDocument?.linkingDocument : undefined

    return (
      <>
        <StepperButton
          title={'ใบวางบิล'}
          state={'passed'}
        />
        <StepperButton
          title={'รับชำระเงิน'}
          state={document.state === 'paid' ? 'passed' : 'pending'}
        />
        <StepperButton
          title={'ใบเสร็จรับเงิน'}
          state={receiptDocument ? 'passed' : 'disabled'}
          onClick={() => {
            if (!receiptDocument) return

            navigate(`/revenue-receipt/${receiptDocument.id}/detail`)
          }}
        />
        <StepperButton
          title={'ออกใบกำกับภาษี'}
          state={taxReceipt ? 'passed' : 'disabled'}
        />
      </>
    )
  }

  const _renderExpenseRequestPurchaseOrder = () => {
    const childrenDocs = document.childrenDocuments

    return (
      <>
        <StepperButton
          title={'ใบขอสั่งซื้อ'}
          state={'passed'}
        />
        <StepperButton
          title={'อนุมัติแล้ว'}
          state={['approved', 'completely'].includes(document.state) ? 'passed' : 'disabled'}
        />
        <StepperButton
          title={'ใบสั่งซื้อ'}
          state={childrenDocs.length ? 'passed' : 'disabled'}
          counter={childrenDocs.length}
          documents={childrenDocs}
          onClick={() => {
            if (!childrenDocs.length) return
            if (childrenDocs.length > 1) return
            navigate(`/expense-purchase-order/${childrenDocs[0].id}/detail`)
          }}
        />
      </>
    )
  }

  const _renderExpensePurchaseOrder = () => {
    return (
      <>
        {document?.linkingDocument && (
          <StepperButton
            title={'ใบขอสั่งซื้อ'}
            state={'passed'}
            onClick={() => {
              navigate(`/expense-request-purchase-order/${document?.linkingDocumentId}/detail`)
            }}
          />
        )}
        <StepperButton
          title={'ใบสั่งซื้อ'}
          state={'passed'}
        />
        <StepperButton
          title={'บันทึกซื้อสินค้า'}
          state={'pending'}
        />
        <StepperButton
          title={'ชำระเงิน'}
          state={'disabled'}
        />
      </>
    )
  }

  return (
    <div className={'d-flex gap-3 mb-4 flex-wrap'}>
      {document.type === IncomeDocumentTypes.QUOTATION && _renderQuotationStepper()}
      {document.type === IncomeDocumentTypes.DEPOSIT && _renderDepositStepper()}
      {document.type === IncomeDocumentTypes.INVOICE && _renderInvoiceStepper()}
      {document.type === IncomeDocumentTypes.RECEIPT && _renderReceiptStepper()}
      {document.type === IncomeDocumentTypes.TAX_INVOICE && _renderTaxInvoiceStepper()}
      {document.type === IncomeDocumentTypes.CREDIT && _renderCreditDebitStepper()}
      {document.type === IncomeDocumentTypes.DEBIT && _renderCreditDebitStepper()}
      {document.type === IncomeDocumentTypes.BILLING && _renderBillingStepper()}
      {document.type === IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER && _renderExpensePurchaseOrder()}
      {document.type === IncomeDocumentTypes.EXPENSE_REQUEST_PURCHASE_ORDER && _renderExpenseRequestPurchaseOrder()}
    </div>
  )
}

export default IncomeDocumentStepper
